import axios from 'axios';
import { API_HOST } from '../helpers/constants';
import { headers } from '../utils';

const baseUrl = `${API_HOST}/blogs`;

export const createBlog = (payload) => {
  return axios.post(`${baseUrl}`, payload, { headers });
};

export const deleteBlog = (id) => {
  return axios.delete(`${baseUrl}/${id}`, { headers });
};

export const updateBlog = (id, payload) => {
  return axios.put(`${baseUrl}/${id}`, payload, { headers });
};
